import { useEffect, useState } from '@wordpress/element';
import styles from "./RadioGroup.module.css";

const RadioGroup = ({ label, name, options = [], selectedValue, onChange }) => {
  const [value, setValue] = useState(selectedValue || "");

  // Update internal value when prop changes
  useEffect(() => {
    // Production: Debug log removed
    // console.log(`🔘 [RadioGroup] ${label} - prop selectedValue changed:`, selectedValue);
    setValue(selectedValue || "");
  }, [selectedValue, label]);

  const handleChange = (e) => {
    // Production: Debug log removed
    // console.log(`🔘 [RadioGroup] ${label} - handleChange:`, e.target.value);
    setValue(e.target.value);
    if (onChange) onChange(e.target.value);
  };

  return (
    <div className={styles["hvnly_settings_api__form-group"]}>
      {label && (
        <label className={styles["hvnly_settings_api__form-label"]}>
          {label}
        </label>
      )}

      <div className={styles["hvnly_settings_api__radio-group"]}>
        {options.map((option) => (
          <label
            key={option.value}
            className={styles["hvnly_settings_api__radio-option"]}
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={handleChange}
            />
            <span className={styles["hvnly_settings_api__radio"]}></span>
            <span className={styles["hvnly_settings_api__radio-label"]}>
              {option.label}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default RadioGroup;